<template>
  <loading :active.sync="isLoading" :is-full-page="fullPage" :color="color" :loader="loader"></loading>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "RwvLoader",
  data() {
    return {
      loader: "dots",
      color: "#007bff"
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    fullPage: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Loading
  },
  methods: {}
};
</script>